<template>
  <div id="homein">
      <b-container id="banner_matricula" v-if="false">
        <b-row align-v="start" class="text-center">
          <b-col align-self="center" style="max-width: 550px" col lg="5">
            <b-img class="sapatilha" :src="require('../img/sapatilha_bale_1.png')" fluid alt="bale"></b-img>
          </b-col>
        </b-row>
        <b-row align-v="start" class="text-center">
          <b-col align-self="center" style="max-width: 550px">
            <h1 class="text sign">Pré-Matrícula aberta</h1>
            <h2 class="text">Faça agora e garanta sua vaga</h2>
            <h3 class="btn-matricula">
              <b-button
                v-if="false"
                type="submit"
                variant="primary"
                @click="openSignup"
              >Começar</b-button>
            </h3>
          </b-col>
        </b-row>
      </b-container>

      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <!-- Text slides with image -->
        <b-carousel-slide>
          <template v-slot:img>
            <img
              class="d-block img-fluid w-100 desktop"
              src="../img/caroussel/slide1_w.jpeg"
              alt="image slot"
            >
            <img
              class="d-block img-fluid w-100 mobile"
              src="../img/caroussel/slide1_h.jpeg"
              alt="image slot"
            >
          </template>
        </b-carousel-slide>

        <!-- Slides with custom text -->
        <b-carousel-slide>
          <template v-slot:img>
            <img
              class="d-block img-fluid w-100 desktop"
              src="../img/caroussel/slide2_w.jpeg"
              alt="image slot"
            >
            <img
              class="d-block img-fluid w-100 mobile"
              src="../img/caroussel/slide2_h.jpeg"
              alt="image slot"
            >
          </template>
        </b-carousel-slide>

        <b-carousel-slide>
          <template v-slot:img>
            <img
              class="d-block img-fluid w-100 desktop"
              src="../img/caroussel/slide3_w.jpeg"
              alt="image slot"
            >
            <img
              class="d-block img-fluid w-100 mobile"
              src="../img/caroussel/slide3_h.jpeg"
              alt="image slot"
            >
          </template>
        </b-carousel-slide>
        <b-carousel-slide>
          <template v-slot:img>
            <img
              class="d-block img-fluid w-100 desktop"
              src="../img/caroussel/slide4_w.jpeg"
              alt="image slot"
            >
            <img
              class="d-block img-fluid w-100 mobile"
              src="../img/caroussel/slide4_h.jpeg"
              alt="image slot"
            >
          </template>
        </b-carousel-slide>
      </b-carousel>
  </div>
</template>

<script>
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "home",
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  methods: {
    animationElement(posEl, isMostrar) {
      let elBanner = document.querySelector('#banner_matricula')
      if (!elBanner) return
      if (isMostrar) {
        elBanner.classList.add('animate__animated', 'animate__backInLeft')
      } else {
        elBanner.classList.remove('animate__animated', 'animate__backInLeft')
      }
    },
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    openSignup() {
      this.$emit('openCadastro')
    },
  }
};
</script>

<style>

h1 {
  padding: 0px;
}

#homein {
  position: relative;
}

#banner_matricula {
  position: absolute;
  top: 20%;
  /*background-color: silver;*/
  z-index: 1;
  margin: 20px;
  padding: 10px;
  font-family: 'Lobster', cursive;
  text-shadow: .1em .1em 0 hsl(346deg 53% 39%);
  /*opacity: 0.5;*/
}

#banner_matricula .text {
  text-align: start;
  padding: 10px;
  letter-spacing: 2px;
  color: #e3acc9;
}

#banner_matricula .sign {
  font-size: 2em;
}


#banner_matricula .btn-matricula {
  text-align: start;
  font-family: 'Arial';
}

#banner_matricula .btn-primary {
  color: #fff;
  background-color: #ff58a5b0;
  border-color: #ff58a5b0;
}

#banner_matricula .btn-primary:hover {
  color: #fff;
  background-color: #da3c86e5;
  border-color: #da3c86e5;
}

#banner_matricula .btn-primary:hover {
  color: #fff;
  background-color: #da3c86e5;
  border-color: #da3c86e5;
}

/* #banner_matricula .sapatilha {
  opacity: 0.5;
}  */

.carousel-indicators {
    padding-bottom: 50px;
    z-index: 4;
}

#carousel-1 .carousel-item .img-fluid {
  width: 100vw !important;
  height:100%;
  min-height: 100vh !important;
  max-height: 100vh !important;
}

#carousel-1 .carousel-item .mobile {
  display: none !important;
}

#carousel-1 .carousel-item .desktop {
  display: block !important;
}

#carousel-1 .carousel-inner img {
  margin: auto;
}

@media screen and (max-width: 767px) {
  #carousel-1 .carousel-item .img-fluid {
    width: 100% !important;
    min-width: 100vw !important;
    height: 100vh !important;
    min-height: 100vh !important;
    max-height: 100vh !important;
  }

  #carousel-1 .carousel-item .mobile {
    display: block !important;
  }

  #carousel-1 .carousel-item .desktop {
    display: none !important;
  }
}


.slide-fade-enter-active {
  transition: all .3s ease;
  transition-delay: 0.3s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-150px);
  opacity: 0;
}

.animate__animated.animate__backInLeft {
  --animate-duration: 1s;
  /*--animate-delay: 5.5s;*/
}

/* This changes all the animations globally */
:root {
  --animate-duration: 900ms;
}

</style>



// WEBPACK FOOTER //
// src/views/home.vue